import { Component, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export interface LifeEvent {
  id: number;
  relativeId: number;
  eventType: string;
  eventDate: string;
  title?: string;
  description?: string;
  location?: string;
  relatedRelativeId?: number;
  relatedRelativeName?: string;
  createdAt: string;
  updatedAt?: string;
}

export interface TimelineResponse {
  events: LifeEvent[];
  relativeId: number;
  relativeName: string;
}

@Component({
  selector: 'app-relative-timeline',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './relative-timeline.component.html',
  styleUrl: './relative-timeline.component.css'
})
export class RelativeTimelineComponent implements OnInit {
  timeline: TimelineResponse | null = null;
  isLoading = true;
  errorMessage = '';
  relativeId: number = 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const id = +params['id'];
      if (id) {
        this.relativeId = id;
        this.loadTimeline(id);
      } else {
        this.errorMessage = 'Invalid relative ID';
        this.isLoading = false;
      }
    });
  }

  loadTimeline(id: number): void {
    this.isLoading = true;
    this.errorMessage = '';
    
    this.http.get<{ success: boolean; data: TimelineResponse; message: string }>(
      `${environment.apiUrl}/api/relative/${id}/timeline`
    ).subscribe({
      next: (response) => {
        if (response.success) {
          this.timeline = response.data;
        } else {
          this.errorMessage = response.message || 'Failed to load timeline';
        }
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading timeline:', error);
        this.errorMessage = error.error?.message || 'Failed to load timeline';
        this.isLoading = false;
      }
    });
  }

  goBack(): void {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigate(['/relative', this.relativeId]);
    }
  }

  formatDate(dateString: string): string {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }

  getEventIcon(eventType: string): string {
    const icons: { [key: string]: string } = {
      'Birth': '👶',
      'Marriage': '💒',
      'Child': '👨‍👩‍👧‍👦',
      'JobStart': '💼',
      'JobEnd': '🏁',
      'Education': '🎓',
      'Death': '🕊️',
      'Other': '📅'
    };
    return icons[eventType] || icons['Other'];
  }

  getEventColor(eventType: string): string {
    const colors: { [key: string]: string } = {
      'Birth': '#4CAF50',
      'Marriage': '#E91E63',
      'Child': '#2196F3',
      'JobStart': '#FF9800',
      'JobEnd': '#9E9E9E',
      'Education': '#9C27B0',
      'Death': '#424242',
      'Other': '#607D8B'
    };
    return colors[eventType] || colors['Other'];
  }
}

